import { Grid, Typography } from "@mui/material";
import CountriesManagement from "./CountriesManagement";

const CountriesManagementUI: React.FC = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingRight: "10px",
            justifyContent: "space-between",
            background: "var(--header)",
            color: "#fff",
            height: "6vh",
            paddingTop: "20px",
          }}
        >
          <Typography
            style={{
              textTransform: "uppercase",
              color: "#fff",
              paddingLeft: "1rem",
            }}
            fontWeight={"bold"}
            variant={"h6"}
          >
            &nbsp;Countries
          </Typography>
        </div>
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ padding: "1.5rem" }}>
          <CountriesManagement />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CountriesManagementUI;
